/* eslint-disable */
// Generic
import HorizontalGridLabels from "../Pulsar/components/HorizontalGridLabels";
import HorizontalGrid from "../Pulsar/components/HorizontalGrid";
import FilterContainer from "../Pulsar/components/Filters/FilterContainer";

// // Bases
import dnaOverlay from "../Pulsar/tracks/dna/DnaOverlay";
import dnaTrackController from "../Pulsar/tracks/dna/dnaTrackController";

// conservation
import conservationTrackController from "../Pulsar/tracks/conservation/conservationTrackController";
import ConservationTitle from "../Pulsar/tracks/conservation/components/ConservationTitle";
import ConservationTooltip from "../Pulsar/tracks/conservation/components/ConservationTooltip";

// Transcripts
import transcriptTrackController from "../Pulsar/tracks/transcripts/transcriptTrackController";
import TranscriptTooltip from "../Pulsar/tracks/transcripts/components/TranscriptTooltip";
import TranscriptsOverlay from "../Pulsar/tracks/transcripts/components/TranscriptsOverlay";
import TranscriptInfo from "../Pulsar/tracks/transcripts/components/TranscriptInfo";

// protein regions
import proteinRegionsController from "../Pulsar/tracks/proteins/ProteinsController";

// // pathogenicity
import PathogenicityTrackController from "../Pulsar/tracks/pathogenicity/pathogenicityTrackController";
import PetalTitle from "../Pulsar/tracks/pathogenicity/components/PetalTitle";
import PetalTooltip from "../Pulsar/tracks/pathogenicity/components/PetalTooltip";

// // Frequencies
import frequencyTrackController from "../Pulsar/tracks/frequencies/frequenciesTrackController";

// Variants
import variantTrackController from "../Pulsar/tracks/variants/variantsTrackController";
import VariantTitle from "../Pulsar/tracks/variants/components/VariantTitle";
import getApiClient from "../Pulsar/apiClient";
import selectionTrackController from "../Pulsar/tracks/selection/selectionTrackController";
import VariantTooltip from "../Pulsar/tracks/variants/components/VariantTooltip";
import ProteinTitle from "../Pulsar/tracks/proteins/components/ProteinTitle";
import ProteinTooltip from "../Pulsar/tracks/proteins/components/ProteinTooltip";

function getRegionBrowserTracks() {
  const {
    loadMainTranscripts,
    getNearbyVariants,
    loadPathogenicity,
    loadSequence,
    loadProteinRegions,
    loadConservation,
  } = getApiClient();

  const maxDnaRange = 10000;
  const maxConservationRange = 300000;
  const maxVariantsRange = 300000;
  const maxRegionRange = 20000000;

  return [
    {
      id: "dna-region-1",
      title: "Dna",
      contentHeight: 25,
      pTop: 0,
      pBottom: 0,
      headerHeight: 0,
      isStickyTop: true,
      OverlayRenderer: dnaOverlay,
      controller: dnaTrackController,
      apiLoader: {
        apiFn: loadSequence,
        maxRange: maxDnaRange,
      },
    },
    {
      id: "conservation-region",
      title: "Conservation Scores",
      contentHeight: 50,
      pTop: 2,
      pBottom: 2,
      TitleRenderer: ConservationTitle,
      TooltipRenderer: ConservationTooltip,
      controller: conservationTrackController,
      apiLoader: {
        apiFn: loadConservation,
        maxRange: maxConservationRange,
      },
    },
    {
      id: "transcrips-region",
      title: "Transcripts",
      contentHeight: 0,
      pTop: 8,
      pBottom: 8,
      FilterRenderer: FilterContainer,
      TooltipRenderer: TranscriptTooltip,
      TitleRenderer: TranscriptInfo,
      OverlayRenderer: TranscriptsOverlay,
      controller: transcriptTrackController,
      apiLoader: {
        apiFn: loadMainTranscripts,
        maxRange: Infinity,
      },
    },
    {
      id: "uniprot-region",
      title: "UniProt Protein Regions",
      helperTextId: "UniProt Protein regions",
      contentHeight: 0,
      pTop: 5,
      pBottom: 5,
      TitleRenderer: ProteinTitle,
      TooltipRenderer: ProteinTooltip,
      controller: proteinRegionsController,
      apiLoader: {
        apiFn: loadProteinRegions,
        maxRange: maxRegionRange,
      },
    },
    {
      id: "patho-region",
      title: "Pathogenicity",
      contentHeight: 120,
      pTop: 18,
      pBottom: 18,
      TitleRenderer: PetalTitle,
      TooltipRenderer: PetalTooltip,
      AxisRenderer: HorizontalGridLabels,
      GridRenderer: HorizontalGrid,
      FilterRenderer: FilterContainer,
      controller: PathogenicityTrackController,
      apiLoader: {
        apiFn: loadPathogenicity,
        maxRange: maxRegionRange,
      },
    },
    {
      id: "freq-region",
      title: "Frequencies",
      contentHeight: 140,
      pTop: 10,
      pBottom: 10,
      TitleRenderer: VariantTitle,
      TooltipRenderer: VariantTooltip,
      AxisRenderer: HorizontalGridLabels,
      FilterRenderer: FilterContainer,
      GridRenderer: HorizontalGrid,
      controller: frequencyTrackController,
      apiLoader: {
        apiFn: getNearbyVariants,
        maxRange: maxVariantsRange,
      },
    },
    {
      id: "var-region",
      title: "Variants",
      contentHeight: 0,
      pTop: 8,
      pBottom: 8,
      FilterRenderer: FilterContainer,
      TitleRenderer: VariantTitle,
      TooltipRenderer: VariantTooltip,
      controller: variantTrackController,
      apiLoader: {
        apiFn: getNearbyVariants,
        maxRange: maxVariantsRange,
      },
    },
    {
      id: "region-btm",
      contentHeight: 400,
      headerHeight: 0,
      controller: () => ({ onReset: () => {}, meshes: [] }),
    },
    {
      id: "overlay-region",
      title: "overlay",
      headerHeight: 0,
      isOverlay: true,
      contentHeight: 0,
      pTop: 0,
      pBottom: 0,
      controller: selectionTrackController,
    },
  ];
}

export default getRegionBrowserTracks;
